import Reveal from "./Reveal";
import { PalaceArch, VineBranch, JasmineStrand, ChainDiya } from "./Ornaments";

const CORNERS = ["tl", "tr", "bl", "br"];

export default function Details() {
  return (
    <section id="details" className="details" data-testid="details-section">
      <Reveal>
        <div className="kicker details-kicker">Wedding Details</div>
        <div className="details-frame">
          {CORNERS.map((c) => (
            <span key={c} className={`fdot fdot-${c}`} aria-hidden="true" />
          ))}
          <div className="details-garland" aria-hidden="true">
            <JasmineStrand width={190} />
          </div>
          <div className="details-chain chain-l" aria-hidden="true">
            <ChainDiya links={4} width={30} dur={6.4} />
          </div>
          <div className="details-chain chain-r" aria-hidden="true">
            <ChainDiya links={5} width={30} delay={0.9} dur={5.8} />
          </div>
          <div className="details-arch">
            <PalaceArch width={112} />
          </div>
          <div className="details-sprig details-sprig-l">
            <VineBranch width={120} flip />
          </div>
          <div className="details-sprig details-sprig-r">
            <VineBranch width={120} />
          </div>
          <h2 className="venue serif">Kesari Mangalam Lawn</h2>
          <div className="address">
            Kanpur–Jhansi Hwy, Damodar Nagar
            <br />
            Kanpur, Uttar Pradesh 208027
          </div>
          <a
            className="map-btn"
            data-testid="view-map-link"
            href="https://maps.app.goo.gl/zmU3c675E8xqXPo56?g_st=ic"
            target="_blank"
            rel="noopener noreferrer"
          >
            View on Map <span>→</span>
          </a>
        </div>
      </Reveal>
    </section>
  );
}
